import { useSelection } from "routes/schedule/lib/useSelection"
import { useTreeItemIndex } from "routes/schedule/lib/useTreeItemIndex"

export function useSelectedItemIds(referenceType = undefined) {
    const selection = useSelection(referenceType)
    const selected = selection[2]
    const treeIndex = useTreeItemIndex(false)
    if (!treeIndex) {
        return Object.entries(selected)
            .filter((c) => !!c[1])
            .map("0")
    }
    return Object.entries(selected)
        .filter((c) => !!c[1])
        .map(resolveSelectedId)
        .filter(Boolean)
        .unique()

    function resolveSelectedId([id, hint]) {
        const normalizedHint = Array.isArray(hint) ? hint[0] : hint
        return treeIndex.retrieve(id, normalizedHint)?._id ?? id
    }
}

export function useSelectedItems(referenceType = undefined) {
    const selection = useSelection(referenceType)
    const selected = selection[2]
    const treeIndex = useTreeItemIndex(false)
    return Object.entries(selected)
        .filter((c) => !!c[1])
        .map((i) => treeIndex.retrieve(...i))
        .filter(Boolean)
        .unique((c) => c._id)
}
